module.exports = __webpack_public_path__ + "img/Logo_Nic_Chile.63f09812.png";